import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { IAccount } from '@account-users/account/models/IAccount';
import {
  AccountCategory,
  AccountCategoryCode,
} from '@account-users/account/models';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountInfoComponent implements OnChanges {
  @Input() accountDetails: IAccount;
  @Input() accountCategories: AccountCategory[];
  @Input() lastUserLoginTime: string;

  private _accountCategoriesDictionary: Record<string, AccountCategory> = {};
  private _hasSubscriptionId = false;

  public get hasSubscriptionId() {
    return this._hasSubscriptionId;
  }

  public get accountCategoriesDictionary() {
    return this._accountCategoriesDictionary;
  }

  public get lockDate(): string {
    if (!this.accountDetails.expirationDate) {
      return 'N/A';
    }
    const exp = new Date(this.accountDetails.expirationDate);
    const lock = new Date(exp.setUTCDate(exp.getUTCDate() + 2));
    return lock.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const accountDetails = changes['accountDetails'];
    if (accountDetails?.currentValue) {
      const ad = accountDetails.currentValue as IAccount;
      this._hasSubscriptionId =
        ad.category === AccountCategoryCode.External ||
        ad.category === AccountCategoryCode.Trial ||
        ad.category === AccountCategoryCode.SuiteMaxo;
    }
    const accountCategories = changes['accountCategories'];
    if (accountCategories?.currentValue) {
      this._accountCategoriesDictionary = (accountCategories?.currentValue as AccountCategory[]).reduce(
        (a, b) => {
          a[b.code] = b;
          return a;
        },
        {},
      );
    }
  }
}
